import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import defaultImage from "../assets/default.png";

interface Student {
  name: string;
  clss: string;
  phone1?: string;
  imageUrl?: string;
  course?: string;
}

const Studentlists: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { background } = state || {};

  const [students, setStudents] = useState<Student[]>([]);
  const [school, setSchool] = useState({ name: "", logo: "" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const allStudents = localStorage.getItem("allStudents");
    const backendResponse = localStorage.getItem("backendResponse");

    if (!allStudents || !backendResponse) {
      setError("No student data found. Please login first.");
      setLoading(false);
      return;
    }

    const studentsData: Student[] = JSON.parse(allStudents);
    const schoolData = JSON.parse(backendResponse);
    if (studentsData.length === 1) {
      localStorage.setItem("selectedStudent", JSON.stringify(studentsData[0]));
      navigate("/dashboardcontent");
      return;
    }
    setStudents(studentsData);
    if (schoolData.objectData) {
      setSchool({
        name: schoolData.objectData.name,
        logo: schoolData.objectData.logoUrl,
      });
    }
    setLoading(false);
  }, []);

  if (loading) return (
    <div className="loading-screen">
      <div className="spinner spinner--lg"></div>
      <p className="loading-text">Loading student...</p>
    </div>
  );

  if (error) return <p className="error-text">{error}</p>;
  const handleClick = (student: Student) => {
    localStorage.setItem("selectedStudent", JSON.stringify(student));
    navigate("/dashboardcontent");
  };

  return (
    <div
      className={`student-details-container ${background ? 'dynamic-background' : ''}`}
      style={{ backgroundImage: background ? `url(${background})` : "none" }}
    >
      <div className="student-card">

        {/* School header */}
        <div className="school-header">
          {school.logo && <img src={school.logo} alt="School Logo" />}
          <h2>{school.name}</h2>
        </div>
        {/* Student list */}
        <div className="student-list">
          {students.map((student, idx) => (
            <div
              key={idx}
              className="student-row"
              onClick={() => handleClick(student)}
            >
              <img
                src={student.imageUrl?.trim() ? student.imageUrl : defaultImage}
                alt={student.name}
                className="student-photo"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).src = defaultImage;
                }}
              />
              <div className="student-info">
                <h3>{student.name}</h3>
                <p>Class: {student.clss} | Course: {student.course}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Studentlists;